import axios from '@utils/axios-client'

export async function getFoodCategoryGroup (params: any = {}) {
  const response = axios.get('/api/v1/FoodCategoryGroup', { params })
  return (await response).data
}
